import { PROWL_RESULTS_ROUTE } from './contracts';

/**
 * Frontend-owned route allowlist for NavigateChip (prowl-components), same
 * pattern as actionAllowlist.ts's action endpoints — the model names a
 * routeKey, never a URL, and this table is the only thing that turns one
 * into an actual in-app path.
 */
const PROWL_ROUTES: Record<string, string> = {
  servicesSearch: PROWL_RESULTS_ROUTE,
};

export const resolveProwlRoute = (routeKey: string): string | null =>
  PROWL_ROUTES[routeKey] ?? null;
